import _ from 'lodash';
import api from '../../utils/service';

const GET_ALL_USERS_SUCCESS = 'redux/user/GET_ALL_USERS_SUCCESS';
const GET_ALL_USERS_FAIL = 'redux/user/GET_ALL_USERS_FAIL';
const GET_USER_SUCCESS = 'redux/user/GET_USER_SUCCESS';
const GET_USER_FAIL = 'redux/user/GET_USER_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        list: action.data,
        error: null,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        detail: action.data,
        error: null,
      };
    case GET_ALL_USERS_FAIL:
    case GET_USER_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getAllUsers() {
  return (dispatch) =>
    api
      .get('/users')
      .then(({ data }) => dispatch(getAllUsersSuccess(data)))
      .catch((error) => dispatch(getAllUsersFail(error)));
}

export function getAllUsersSuccess(data) {
  return {
    type: GET_ALL_USERS_SUCCESS,
    data,
  };
}

export function getAllUsersFail(error) {
  return {
    type: GET_ALL_USERS_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function getUser(_id) {
  return (dispatch) =>
    api
      .get(`/users/${_id}`)
      .then(({ data }) => dispatch(getUserSuccess(data)))
      .catch((error) => dispatch(getUserFail(error)));
}

export function getUserSuccess(data) {
  return {
    type: GET_USER_SUCCESS,
    data,
  };
}

export function getUserFail(error) {
  return {
    type: GET_USER_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
